import React from 'react'
import styled, { css } from 'styled-components';
import { useFormContext } from 'react-hook-form'

type Props = {
  name: string,
  options: string[],
  defaultValue?: string,
  required?: boolean,
  disabled?: boolean,
}

const StyledRadio = styled.div`
  display: flex;
  margin: 1.25rem auto 1rem;
`

const StyledRadioLabel = styled.label<{ disabled: boolean }>`
  font-size: .875rem;
  margin-right: 1.5rem;
  margin-bottom: 1rem;
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
    `}
`

const StyledRadioInput = styled.input`
  margin: auto .5rem auto 0;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
}
`

export const StyledRadioForm: React.FC<Props> = (props: Props) => {
  const { register } = useFormContext()

  return (
    <StyledRadio>
      {props.options.map((option: string, index) => (
        <StyledRadioLabel key={index} disabled={props.disabled}>
          <StyledRadioInput
            name={props.name}
            type='radio'
            value={option}
            defaultChecked={props.defaultValue === option}
            // TODO react-hook-formを使ったバリデーションエラーメッセージ表示の実装をしたい
            required={props.required}
            disabled={props.disabled}
            {...register(props.name, { required: { value: props.required } })}
          />
          {option}
        </StyledRadioLabel>
      ))}
    </StyledRadio>
  )
}
